import React from 'react';

import './style/index.css';

import App from './App';
import { renderReactRoot } from './utils/renderReactRoot';

// TODO: React 18:
// NOTE: These changes are optional.
//   import { createRoot } from 'react-dom/client';
//   const container = document.getElementById('app');
//   const root = createRoot(container); // createRoot(container!) if you use TypeScript
//   root.render(<App tab="home" />);
// Without these changes, react 18 will run our app in "react 17 mode".
// That is likely the best of both worlds
renderReactRoot(<App />, 'ccg-hosted-root');
